export default __webpack_public_path__ + "static/B0135-f9fdec55dbe9a45f9abd815250790efd.png";